import {createFeatureSelector, createSelector} from '@ngrx/store';
import {selectActiveLesson} from './selectors';
import * as fromAssessmentAttempts from './assessment-attempts.reducer';
import {AssessmentAttemptsState} from './assessment-attempts.reducer';


export const selectAssessmentAttemptsState = createFeatureSelector<AssessmentAttemptsState>("assessmentAttempts");


export const selectAllAssessmentAttempts = createSelector(
  selectAssessmentAttemptsState,
  fromAssessmentAttempts.selectAll
);

export const selectActiveLessonAssessmentAttempt = createSelector(
  selectActiveLesson,
  selectAllAssessmentAttempts,
  (lesson, attempts) => attempts.find(attempt => attempt.assessmentId == lesson.id)
);
